import { DataTypeConfig } from "../../../../types";

export const metersConfig: DataTypeConfig = {
  tabs: [
    "utilityService",
    "category",
    "subCategory",
    "meterType",
    "meterModel",
    "manufacturer",
  ],
  searchableColumns: [
    "meter_number",
    "device_no",
    "meter_model",
    "premise",
    "utility_service",
    "category",
    "sub_category",
    "meter_type",
    "manufacturer",
  ],
  filterColumns: [
    { column: "utility_service", type: "dropdown", label: "Utility Service" },
    { column: "category", type: "dropdown", label: "Category" },
    { column: "sub_category", type: "dropdown", label: "Sub Category" },
    { column: "meter_type", type: "dropdown", label: "Meter Type" },
    { column: "manufacturer", type: "dropdown", label: "Manufacturer" },
    { column: "installed_on", type: "date", label: "Installed On" },
    {
      column: "current_reading_date",
      type: "date",
      label: "Current Reading Date",
    },
    {
      column: "previous_reading_date",
      type: "date",
      label: "Previous Reading Date",
    },
  ],
  tableColumns: [
    { key: "meter_number", header: "Meter Number", type: "custom" },
    { key: "utility_service", header: "Utility Service", type: "badge" },
    { key: "category", header: "Category", type: "badge" },
    { key: "sub_category", header: "Sub Category", type: "badge" },
    { key: "meter_type", header: "Meter Type", type: "badge" },
    { key: "device_no", header: "Device No", type: "custom" },
    { key: "meter_model", header: "Meter Model", type: "custom" },
    { key: "premise", header: "Premise", type: "custom" },
    {
      key: "current_reading_date",
      header: "Current Reading Date",
      type: "custom",
    },
    { key: "current_reading", header: "Current Reading", type: "custom" },
    {
      key: "previous_reading_date",
      header: "Previous Reading Date",
      type: "custom",
    },
    { key: "previous_reading", header: "Previous Reading", type: "custom" },
    { key: "long", header: "Longitude", type: "custom" },
    { key: "lat", header: "Latitude", type: "custom" },
    { key: "installed_on", header: "Installed On", type: "custom" },
    { key: "floor", header: "Floor", type: "custom" },
    { key: "floor_unit", header: "Floor Unit", type: "custom" },
    { key: "manufacturer", header: "Manufacturer", type: "badge" },
  ],
  mandatoryFields: [
    "meter_number",
    "utility_service",
    "category",
    "meter_type",
    "meter_model",
    "premise",
    "installed_on",
    "manufacturer",
  ],
};

export const metersTabDisplayNames: Record<string, string> = {
  utilityService: "Utility Service",
  category: "Category",
  subCategory: "Sub Category",
  meterType: "Meter Type",
  meterModel: "Meter Model",
  manufacturer: "Manufacturer",
};

export const metersTabDropdownOptions = (tabName: string) => {
  switch (tabName) {
    case "utilityService":
      return [
        { value: "electricity", label: "Electricity" },
        { value: "water", label: "Water" },
        { value: "gas", label: "Gas" },
      ];
    case "category":
      return [
        { value: "residential", label: "Residential" },
        { value: "commercial", label: "Commercial" },
        { value: "industrial", label: "Industrial" },
      ];
    case "subCategory":
      return [
        { value: "single_phase", label: "Single Phase" },
        { value: "three_phase", label: "Three Phase" },
        { value: "smart_meter", label: "Smart Meter" },
      ];
    case "meterType":
      return [
        { value: "smart", label: "Smart" },
        { value: "manual", label: "Manual" },
        { value: "photo", label: "Photo" },
      ];
    case "meterModel":
      return [
        { value: "model_x100", label: "Model X100" },
        { value: "smartmeter_pro", label: "SmartMeter Pro" },
        { value: "analog_2024", label: "Analog-2024" },
      ];
    case "manufacturer":
      return [
        { value: "abb", label: "ABB" },
        { value: "siemens", label: "Siemens" },
        { value: "schneider", label: "Schneider Electric" },
      ];
    default:
      return [];
  }
};
